import type { FC } from 'react'
import React from 'react'
import { useSelector } from 'react-redux'
import { BubblingTooltip, Button, Image } from '@/components/ui'
import { isAuthenticated as isUserAuthenticated, isUserAgrarian } from '@/logic/auth/reducer'
import type { RootState } from '@/redux/interfaces'
import { useWebpExtension } from '@/utils/hooks/image'
import { LandingBlockContainer } from '..'
import { markImages } from './constants'
import type { ILeasingMachineMarksProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const mapState = (state: RootState) => ({
  isAgrarian: isUserAgrarian()(state),
  isAuthenticated: isUserAuthenticated()(state),
})

const LeasingMachineMarks: FC<ILeasingMachineMarksProps> = ({ onActionClick, blockId, buttonTooltipMessage }) => {
  const imageExtension = useWebpExtension()
  const { isAgrarian, isAuthenticated } = useSelector(mapState)
  const shouldDisableButton = isAuthenticated && !isAgrarian

  const leaveRequestButton = (
    <Button
      modifiers={['green']}
      textId={messages.leaveRequest}
      onClick={onActionClick}
      isDisabled={Boolean(buttonTooltipMessage) && shouldDisableButton}
    />
  )

  return (
    <LandingBlockContainer titleId={messages.title} titleClassName="space-holder24">
      <div className="landing-constructor-leasing-machine wide-mobile-block space-holder4 space-holder2-sm" id={blockId}>
        <h2 className="color_white">{messages.banner.title}</h2>
      </div>
      <ul className="landing-constructor-leasing-machine-marks space-holder48 space-holder32-sm wide-mobile-block">
        {markImages.map(carBrandName => (
          <li className="landing-constructor-leasing-machine-mark" key={carBrandName}>
            <Image
              src={`/machineMarks/${carBrandName}.${imageExtension}`}
              className="landing-constructor-leasing-machine-mark__image"
              isInStatic
            />
            <div className="space-holder-left32-from-sm landing-constructor-leasing-machine-mark__text">
              <h4 className="space-holder4-sm">{messages.price[carBrandName]}</h4>
              <span className="text_small colo_pale-black">{messages.perMonth}</span>
            </div>
          </li>
        ))}
      </ul>
      {buttonTooltipMessage && shouldDisableButton ? (
        <BubblingTooltip content={buttonTooltipMessage}>
          <span className="inline-block landing-constructor-leasing-machine__button-wrapper">{leaveRequestButton}</span>
        </BubblingTooltip>
      ) : (
        leaveRequestButton
      )}
    </LandingBlockContainer>
  )
}

export default LeasingMachineMarks
